// Simmons Luxury Collection + SmartLife + King Koil (scraped).
export const EXTRA_CATALOG = [
 {
  "slug": "escape-no-1-extra-firm-15",
  "name": "Escape No. 1",
  "brand": "simmons",
  "category": "mattresses",
  "price": 5599,
  "compareAt": null,
  "priceFrom": true,
  "sku": "",
  "firmness": "Extra Firm",
  "height": "15\"",
  "type": "Innerspring",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://simmons.com/cdn/shop/files/EscapeNo1_01_Front.png?v=1781045530&width=800",
  "gallery": [
   "https://simmons.com/cdn/shop/files/EscapeNo1_01_Front.png?v=1781045530&width=800"
  ],
  "description": "The Escape No. 1 from Simmons delivers extra firm comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "escape-no-2-medium-15",
  "name": "Escape No. 2",
  "brand": "simmons",
  "category": "mattresses",
  "price": 5599,
  "compareAt": null,
  "priceFrom": true,
  "sku": "",
  "firmness": "Medium",
  "height": "15\"",
  "type": "Innerspring",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://simmons.com/cdn/shop/files/EscapeNo1_01_Front_b01eae71-014c-4bfc-9f4f-47dd2761e490.png?v=1781045583&width=800",
  "gallery": [
   "https://simmons.com/cdn/shop/files/EscapeNo1_01_Front_b01eae71-014c-4bfc-9f4f-47dd2761e490.png?v=1781045583&width=800"
  ],
  "description": "The Escape No. 2 from Simmons delivers medium comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "escape-no-3-plush-15",
  "name": "Escape No. 3",
  "brand": "simmons",
  "category": "mattresses",
  "price": 5599,
  "compareAt": null,
  "priceFrom": true,
  "sku": "",
  "firmness": "Plush",
  "height": "15\"",
  "type": "Innerspring",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://simmons.com/cdn/shop/files/EscapeNo1_01_Front_b22cf5c5-6795-4640-bd53-c7ad878d857f.png?v=1781045627&width=800",
  "gallery": [
   "https://simmons.com/cdn/shop/files/EscapeNo1_01_Front_b22cf5c5-6795-4640-bd53-c7ad878d857f.png?v=1781045627&width=800"
  ],
  "description": "The Escape No. 3 from Simmons delivers plush comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "escape-no-4-firm-15-5",
  "name": "Escape No. 4",
  "brand": "simmons",
  "category": "mattresses",
  "price": 5999,
  "compareAt": null,
  "priceFrom": true,
  "sku": "",
  "firmness": "Firm",
  "height": "15.5\"",
  "type": "Innerspring",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://simmons.com/cdn/shop/files/EscapeNo1_01_Front_2af7a0be-dffb-4807-863c-655e61a6eb91.png?v=1781045651&width=800",
  "gallery": [
   "https://simmons.com/cdn/shop/files/EscapeNo1_01_Front_2af7a0be-dffb-4807-863c-655e61a6eb91.png?v=1781045651&width=800"
  ],
  "description": "The Escape No. 4 from Simmons delivers firm comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "escape-no-5-medium-15-5",
  "name": "Escape No. 5",
  "brand": "simmons",
  "category": "mattresses",
  "price": 5999,
  "compareAt": null,
  "priceFrom": true,
  "sku": "",
  "firmness": "Medium",
  "height": "15.5\"",
  "type": "Innerspring",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://simmons.com/cdn/shop/files/EscapeNo1_01_Front_e6762988-b116-43df-b03d-48e384315dea.png?v=1781045693&width=800",
  "gallery": [
   "https://simmons.com/cdn/shop/files/EscapeNo1_01_Front_e6762988-b116-43df-b03d-48e384315dea.png?v=1781045693&width=800"
  ],
  "description": "The Escape No. 5 from Simmons delivers medium comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "escape-no-6-plush-pillow-top-16",
  "name": "Escape No. 6",
  "brand": "simmons",
  "category": "mattresses",
  "price": 6999,
  "compareAt": null,
  "priceFrom": true,
  "sku": "",
  "firmness": "Plush Pillow Top",
  "height": "16\"",
  "type": "Innerspring",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://simmons.com/cdn/shop/files/EscapeNo6_01_Front.png?v=1781045740&width=800",
  "gallery": [
   "https://simmons.com/cdn/shop/files/EscapeNo6_01_Front.png?v=1781045740&width=800"
  ],
  "description": "The Escape No. 6 from Simmons delivers plush pillow top comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "escape-no-7-firm-pillow-top-16-5",
  "name": "Escape No. 7",
  "brand": "simmons",
  "category": "mattresses",
  "price": 7999,
  "compareAt": null,
  "priceFrom": true,
  "sku": "",
  "firmness": "Firm Pillow Top",
  "height": "16.5\"",
  "type": "Innerspring",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://simmons.com/cdn/shop/files/EscapeNo6_01_Front_62eef597-58f2-4171-bd63-1931db267b74.png?v=1781045771&width=800",
  "gallery": [
   "https://simmons.com/cdn/shop/files/EscapeNo6_01_Front_62eef597-58f2-4171-bd63-1931db267b74.png?v=1781045771&width=800"
  ],
  "description": "The Escape No. 7 from Simmons delivers firm pillow top comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "escape-no-8-medium-firm-pillow-top-16-5",
  "name": "Escape No. 8",
  "brand": "simmons",
  "category": "mattresses",
  "price": 7999,
  "compareAt": null,
  "priceFrom": true,
  "sku": "",
  "firmness": "Medium-Firm Pillow Top",
  "height": "16.5\"",
  "type": "Innerspring",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://simmons.com/cdn/shop/files/EscapeNo6_01_Front_f720e2f4-267f-43bb-9696-e0150f1cec5e.png?v=1781045972&width=800",
  "gallery": [
   "https://simmons.com/cdn/shop/files/EscapeNo6_01_Front_f720e2f4-267f-43bb-9696-e0150f1cec5e.png?v=1781045972&width=800"
  ],
  "description": "The Escape No. 8 from Simmons delivers medium-firm pillow top comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "escape-no-9-medium-plush-pillow-top-17",
  "name": "Escape No. 9",
  "brand": "simmons",
  "category": "mattresses",
  "price": 8999,
  "compareAt": null,
  "priceFrom": true,
  "sku": "",
  "firmness": "Medium-Plush Pillow Top",
  "height": "17\"",
  "type": "Innerspring",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://simmons.com/cdn/shop/files/EscapeNo9_01_Front.png?v=1781045845&width=800",
  "gallery": [
   "https://simmons.com/cdn/shop/files/EscapeNo9_01_Front.png?v=1781045845&width=800"
  ],
  "description": "The Escape No. 9 from Simmons delivers medium-plush pillow top comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "escape-no-10-plush-pillow-top-17-5",
  "name": "Escape No. 10",
  "brand": "simmons",
  "category": "mattresses",
  "price": 9999,
  "compareAt": null,
  "priceFrom": true,
  "sku": "",
  "firmness": "Plush Pillow Top",
  "height": "17.5\"",
  "type": "Innerspring",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://simmons.com/cdn/shop/files/EscapeNo9_01_Front_f45ba3b2-fe18-45be-9fab-8e25adb31ef5.png?v=1781045877&width=800",
  "gallery": [
   "https://simmons.com/cdn/shop/files/EscapeNo9_01_Front_f45ba3b2-fe18-45be-9fab-8e25adb31ef5.png?v=1781045877&width=800"
  ],
  "description": "The Escape No. 10 from Simmons delivers plush pillow top comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "escape-no-11-medium-pillow-top-18",
  "name": "Escape No. 11",
  "brand": "simmons",
  "category": "mattresses",
  "price": 10999,
  "compareAt": null,
  "priceFrom": true,
  "sku": "",
  "firmness": "Medium Pillow Top",
  "height": "18\"",
  "type": "Innerspring",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://simmons.com/cdn/shop/files/EscapeNo9_01_Front_e91156f4-0049-42b4-b2f9-50963a19c84c.png?v=1781045913&width=800",
  "gallery": [
   "https://simmons.com/cdn/shop/files/EscapeNo9_01_Front_e91156f4-0049-42b4-b2f9-50963a19c84c.png?v=1781045913&width=800"
  ],
  "description": "The Escape No. 11 from Simmons delivers medium pillow top comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "smartlife-calla-plush-mattress",
  "name": "SmartLife Calla Adjustable Mattress",
  "brand": "smartlife",
  "category": "mattresses",
  "price": 4799,
  "compareAt": 5199,
  "priceFrom": true,
  "sku": "",
  "firmness": "Plush",
  "height": "-",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Queen",
   "King",
   "California King",
   "Split Top King"
  ],
  "image": "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/SmartLife_Calla_SplitKing_Mattress_Room.jpg?v=1708550707&width=800",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/SmartLife_Calla_SplitKing_Mattress_Room.jpg?v=1708550707&width=800"
  ],
  "description": "The SmartLife Calla Adjustable Mattress from SmartLife by King Koil delivers plush comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal. Smart body-sensing technology adjusts to your position all night."
 },
 {
  "slug": "smartlife-medium-adjustable-mattress",
  "name": "SmartLife Lily 2.0 Adjustable Mattress",
  "brand": "smartlife",
  "category": "mattresses",
  "price": 4299,
  "compareAt": 4699,
  "priceFrom": true,
  "sku": "",
  "firmness": "Medium",
  "height": "-",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Queen",
   "King",
   "California King",
   "Split Top King"
  ],
  "image": "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/SL_split_lifestyle_1-small.jpg?v=1719340016&width=800",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/SL_split_lifestyle_1-small.jpg?v=1719340016&width=800"
  ],
  "description": "The SmartLife Lily 2.0 Adjustable Mattress from SmartLife by King Koil delivers medium comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal. Smart body-sensing technology adjusts to your position all night."
 },
 {
  "slug": "king-koil-natural-retreat-glacial-mist-pillow-top-medium-mattress",
  "name": "King Koil Natural Retreat Glacial Mist Pillow Top Medium Mattress",
  "brand": "king-koil",
  "category": "mattresses",
  "price": 2999,
  "compareAt": 3199,
  "variants": {
   "Twin": { "price": 2999, "compareAt": 3199 },
   "Twin XL": { "price": 3099, "compareAt": 3299 },
   "Full": { "price": 3199, "compareAt": 3399 },
   "Queen": { "price": 3299, "compareAt": 3499 },
   "King": { "price": 3499, "compareAt": 3699 },
   "California King": { "price": 3499, "compareAt": 3699 }
  },
  "priceFrom": true,
  "sku": "",
  "firmness": "Medium",
  "height": "-",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/GlacialMistMedPtopSplitFrontLifestyleSQUARE.jpg?v=1758818138&width=800",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/GlacialMistMedPtopSplitFrontLifestyleSQUARE.jpg?v=1758818138&width=800"
  ],
  "description": "The King Koil Natural Retreat Glacial Mist Pillow Top Medium Mattress from King Koil delivers medium comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "king-koil-natural-retreat-cascade-drift-firm-mattress",
  "name": "King Koil Natural Retreat Cascade Drift Firm Mattress",
  "brand": "king-koil",
  "category": "mattresses",
  "price": 2599,
  "compareAt": 2799,
  "variants": {
   "Twin": { "price": 2599, "compareAt": 2799 },
   "Twin XL": { "price": 2699, "compareAt": 2899 },
   "Full": { "price": 2799, "compareAt": 2999 },
   "Queen": { "price": 2899, "compareAt": 3099 },
   "King": { "price": 3099, "compareAt": 3299 },
   "California King": { "price": 3099, "compareAt": 3299 }
  },
  "priceFrom": true,
  "sku": "",
  "firmness": "Firm",
  "height": "-",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/CascadeDriftFirmTTSplitFrontLifestyleSQUARE.jpg?v=1758815931&width=800",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/CascadeDriftFirmTTSplitFrontLifestyleSQUARE.jpg?v=1758815931&width=800"
  ],
  "description": "The King Koil Natural Retreat Cascade Drift Firm Mattress from King Koil delivers firm comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "king-koil-natural-retreat-cascade-drift-plush-mattress",
  "name": "King Koil Natural Retreat Cascade Drift Plush Mattress",
  "brand": "king-koil",
  "category": "mattresses",
  "price": 2599,
  "compareAt": 2799,
  "variants": {
   "Twin": { "price": 2599, "compareAt": 2799 },
   "Twin XL": { "price": 2699, "compareAt": 2899 },
   "Full": { "price": 2799, "compareAt": 2999 },
   "Queen": { "price": 2899, "compareAt": 3099 },
   "King": { "price": 3099, "compareAt": 3299 },
   "California King": { "price": 3099, "compareAt": 3299 }
  },
  "priceFrom": true,
  "sku": "",
  "firmness": "Plush",
  "height": "-",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/CascadeDriftPLTTFrontLifestyleSQUARE.jpg?v=1758818091&width=800",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/CascadeDriftPLTTFrontLifestyleSQUARE.jpg?v=1758818091&width=800"
  ],
  "description": "The King Koil Natural Retreat Cascade Drift Plush Mattress from King Koil delivers plush comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 },
 {
  "slug": "king-koil-natural-retreat-glacial-mist-pillow-top-plush-mattress",
  "name": "King Koil Natural Retreat Glacial Mist Pillow Top Plush Mattress",
  "brand": "king-koil",
  "category": "mattresses",
  "price": 2999,
  "compareAt": 3199,
  "variants": {
   "Twin": { "price": 2999, "compareAt": 3199 },
   "Twin XL": { "price": 3099, "compareAt": 3299 },
   "Full": { "price": 3199, "compareAt": 3399 },
   "Queen": { "price": 3299, "compareAt": 3499 },
   "King": { "price": 3499, "compareAt": 3699 },
   "California King": { "price": 3499, "compareAt": 3699 }
  },
  "priceFrom": true,
  "sku": "",
  "firmness": "Plush",
  "height": "-",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "image": "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/GlacialMistPlushPtopFrontLifestyleSQUARE.jpg?v=1758818198&width=800",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/0657/8752/7425/files/GlacialMistPlushPtopFrontLifestyleSQUARE.jpg?v=1758818198&width=800"
  ],
  "description": "The King Koil Natural Retreat Glacial Mist Pillow Top Plush Mattress from King Koil delivers plush comfort with premium materials and total-body support, hand-built for restorative, cooler sleep. Available in all sizes at MattressTown with local delivery, set-up and old-mattress removal."
 }
];
